import { Typography } from "@material-ui/core";
import React, { FunctionComponent } from "react";

export const EmptyVisitDetails: FunctionComponent = () => (
  <Typography variant="h3" component="p">
    Please select a visit to see additional details.
  </Typography>
);
